exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paper-set>p {\r\n    color: #333 !important;\r\n}\r\n\r\n.paper-set .paper-set-title {\r\n    color: #84ad05 !important;\r\n}\r\n\r\n.summary {\r\n    margin-top: 0px !important;\r\n}\r\n\r\n.paper-count {\r\n    color: #313131;\r\n}\r\n\r\n/* Extra small devices (phones, less than 768px) */\r\n\r\n/* No media query since this is the default in Bootstrap */\r\n\r\n/* Small devices (tablets, 768px and up) */\r\n\r\n@media (min-width: 768px) {\r\n    .summary {\r\n        margin-left: 0px;\r\n        margin-bottom: 120px;\r\n    }\r\n}\r\n\r\n/* Medium devices (desktops, 992px and up) */\r\n\r\n@media (min-width: 992px) {}\r\n\r\n/* Large devices (large desktops, 1200px and up) */\r\n\r\n@media (min-width: 1200px) {}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/css/report-papers.component.css
// module id = ../../../../../src/app/css/report-papers.component.css
// module chunks = main